import { keepPreviousData } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useMemo } from 'react';

import useAIConversation, {
  AIConversationMessageFinished,
  AIConversationParams,
} from '@/client/BFF/AIConversation/useAIConversation';

const useBuildAIConversationHistory = (params: AIConversationParams, opts?: { enabled?: boolean; poll?: boolean }) => {
  const poll = opts?.poll ?? true;
  const {
    data: conversation,
    isLoading,
    refetch,
  } = useAIConversation(params, {
    enabled: opts?.enabled,
    placeholderData: keepPreviousData,
    retry: poll ? (failureCount, error) => (error as AxiosError)?.response?.status === 404 && failureCount < 3 : false,
    retryDelay: poll ? 2000 : undefined,
    refetchInterval: poll
      ? (data) => {
          if ((data.state.error as AxiosError)?.response?.status === 404) return false;
          const conv = data.state.data?.data;
          if (!conv || conv.length === 0) return 2000;
          const last = conv[conv.length - 1];
          if (last.status === 'running') return 2000;
          return false;
        }
      : false,
  });
  const { history, inProgress } = useMemo(() => {
    if (!conversation || conversation.length === 0) {
      return { history: [] as AIConversationMessageFinished[], inProgress: null };
    }
    const last = conversation[conversation.length - 1];
    if (last.status !== 'running') {
      return { history: conversation as AIConversationMessageFinished[], inProgress: null };
    } else {
      const history = conversation.slice(0, -1) as AIConversationMessageFinished[];
      return { history, inProgress: last };
    }
  }, [conversation]);
  return { history, inProgress, isLoading, refetch };
};
export default useBuildAIConversationHistory;
